<template>
  <div class="table-container">
    <div v-if="loading === true">
      <tr>
        <td colspan="10">
          <SkeletonForReport />
        </td>
      </tr>
    </div>
    <table v-else>
      <thead>
        <tr>
          <th class="first-column"></th>
          <th class="headerElem" v-for="project in projectData" :key="project.id">

            <div class="headerText"><span>{{ getProjectData(project.code) }}
                <v-tooltip activator="parent">{{ project.code }}
                </v-tooltip>
              </span>
              <span class="sort">
                <i :class="[
                  'pi',
                  sortId === project.id
                    ? (sortDirection === 'asc' ? 'pi-sort-numeric-up' : 'pi-sort-numeric-down-alt')
                    : 'pi-sort-numeric-down-alt',
                  'show-cursor',
                  'rotate-90'
                ]" @click="getSortTheData(project.id)"></i>
              </span>
            </div>

          </th>
          <th class="headerElem total-column total-header-cell">
            <div class="headerText total-header">Total</div>
            <span class="sort1">
              <i :class="['pi', totalSortDirection !== 'asc' ? 'pi-sort-numeric-up' : 'pi-sort-numeric-down-alt',
                'show-cursor',]" @click="getSortTheTotalData()"></i>
            </span>
          </th>

        </tr>
      </thead>
      <tbody class="scrollable-body">

        <tr v-for="account in accounData" :key="account.id">
          <td>
            <span style="font-weight: bold" class="headerElem account-name">
              {{ account.name }}</span>
          </td>
          <td v-for="project in projectData" :key="project">
            <div @click="
              issueData(project.id, account.id)
              " class="project-cell" style="font-weight: bold; cursor: pointer">
              {{ getCellValue(project.id, account.id) || "-" }}
            </div>
          </td>

          <td class="total-column-cell">
            <span style="font-weight: bold;cursor: pointer;" @click="issueData(null, account.id)">
              {{
                this.switchData === "estimate"
                  ? getAccountTotal(account.id)
                  : getAccountTotal(account.id)
              }}
            </span>
          </td>
        </tr>
      </tbody>
      <tfoot>
        <tr class="total-row">
          <td class="total-column-cell">Total</td>
          <td style="background-color: #eef6fb;width: 30px;" class="total-column-cell" v-for="project in projectData"
            :key="project.id">
            <span style="font-weight: bold;cursor: pointer;" @click="issueData(project.id, null)">
              {{
                this.switchData === "estimate"
                  ? getProjectTotal(project.id)
                  : getProjectTotal(project.id)
              }}</span>
          </td>
          <td class="total-column-cell">
            <span style="font-weight: bold">
              {{ this.switchData === "estimate" ? getTotal() : getTotal() }}
            </span>
          </td>
        </tr>
      </tfoot>
    </table>
  </div>
</template>

<script>
import ProductionDashboardService from "@/api/service/ProductionDashboard/ProductionDashboard";
import commonService from "@/common.service";
import SkeletonForReport from "./SkeletonForReport.vue";
import lodash from 'lodash'
export default {
  components: {
    SkeletonForReport,
  },
  props: ["filterData", "switchData"],
  data() {
    return {
      ProductionData: null,
      loading: false,
      accounData: [],
      projectData: [],
      sortId: null,
      sortDirection: 'asc',
      totalSortDirection: 'asc',
      backupAccountData: []
    };
  },
  created() {
    this.sortId = localStorage.getItem('LB_SORT')
    this.getProductionData();
  },
  computed: {
  },
  watch: {
    filterData() {
      if (this.filterData) {
        this.getProductionData(this.filterData);
      }
    },
  },
  methods: {
    async uniqueData() {
      this.accounData = []
      let accountId = [];
      this.projectData = []
      let projectId = [];
      if (this.ProductionData) {
        this.ProductionData.forEach((item) => {
          console.log(item, 'iiiiiii')
          if (!accountId.includes(item.account_id)) {
            this.accounData.push({ id: item.account_id, name: item.account_name })
            accountId.push(item.account_id)
          }
          if (!projectId.includes(item.project_id)) {
            this.projectData.push({ id: item.project_id, name: item.project_name, code: item.code })
            console.log(this.projectData, 'ssssssss')
            projectId.push(item.project_id)
          }
        });
        this.projectData = await commonService.getSort(this.projectData, 'name', 'asc')
        this.accounData = await commonService.getSort(this.accounData, 'name', 'asc')
        this.backupAccountData = JSON.parse(JSON.stringify(this.accounData))
      }
    },
    async getProductionData(filter) {
      this.loading = true
      let res = await ProductionDashboardService.liveBoardData(filter ? filter : {});
      this.ProductionData = res.length > 0 ? res : [];
      console.log(res, 'you')
      this.loading = false
      if (this.sortId) {
        this.getSortTheData(this.sortId)
      }
      this.uniqueData()
    },

    async getFilterDashboardData(data) {
      let obj = {};

      if (data.priority && data.priority.length > 0) {
        obj.priority = [...data.priority];
      }

      if (data.timeData && data.timeData.data_value) {
        obj.timeData = data.timeData.data_value;
      }

      let res = await ProductionDashboardService.findAll(obj);
      this.ProductionData = res.length > 0 ? res : [];
    },

    getCellValue(wId, aId) {
      let data = this.ProductionData.filter(k => k.project_id == wId && k.account_id == aId)
      if (data && data.length > 0) {
        // return !this.switchData || this.switchData =='issues' ?Math.floor(data[0].total_issues):Math.floor(data[0].estimated)
        if (!this.switchData || this.switchData === 'issues') {
          return Math.floor(data[0].total_issues);
        } else if (this.switchData === 'estimate') {
          return Math.floor(data[0].estimated);
        } else if (this.switchData === 'quantity') {
          return Math.floor(data[0].quantity);
        }

      }
    },
    // getSortTheData(wId){
    //   console.log(wId,'huhuhu',this.ProductionData,"#####")
    //   this.sortId = wId
    //   localStorage.setItem('LB_SORT',wId)
    //   const sortKey = !this.switchData || this.switchData === 'issues' ? 'total_issues' : 'estimated';
    //   console.log(this.ProductionData,'orderBy')
    //   this.ProductionData = lodash.orderBy(this.ProductionData, [
    //             (item) => item.project_id === wId ? 0 : 1,
    //             (item) => item.account_id,
    //             (item) => item[sortKey]
    //         ], ['asc', 'asc', 'asc']);
    //   this.projectData = this.ProductionData.map(i => [i.project_id, i[sortKey]])
    //   console.log(this.projectData,'higggg')
    //   this.uniqueData()
    // },

    getSortTheData(wId) {
      console.log(wId, 'W ID #');
      console.log(this.sortId, 'sort_id #')
      this.totalSortDirection = 'asc'
      if (this.sortId === wId) {
        this.sortDirection = this.sortDirection === 'asc' ? 'desc' : 'asc';
      } else {
        this.sortId = wId;
        this.sortDirection = 'asc';
      }

      this.sortId = wId;
      localStorage.setItem('LB_SORT', wId)
      this.sortId = wId ? wId : localStorage.getItem('LB_SORT');
      console.log(this.sortId, '$$####')
      // const sortKey = !this.switchData || this.switchData === 'issues' ? 'total_issues' : 'estimated';
      let sortKey = 'total_issues';
      if (this.switchData === 'estimated') {
        sortKey = 'estimated';
      } else if (this.switchData === 'quantity') {
        sortKey = 'quantity';
      }
      console.log(this.sortId, "sort id ###", sortKey)
      console.log(this.ProductionData, "production data ###")
      const filteredData = this.ProductionData.filter(item => item.project_id === this.sortId);
      console.log(filteredData, 'filll###')

      const sortedData = lodash.orderBy(filteredData, [sortKey, 'account_name'], [this.sortDirection]);
      console.log(sortedData, 'sort###')
      let accountIdData = []
      let $accountData = []

      for (let item of sortedData) {
        accountIdData.push(item.account_id)
        $accountData.push({ id: item.account_id, name: item.account_name })
      }
      console.log(accountIdData, 'id###')
      console.log($accountData, 'sortData#####')

      for (let item of this.backupAccountData) {
        console.log(item, '7777')
        if (!accountIdData.includes(item.id)) {
          $accountData.push(item)
        }
      }

      console.log($accountData, 'backupData####')
      this.accounData = { ...$accountData }
      console.log($accountData, "#######")
    },
    getSortTheTotalData() {
      this.sortDirection = 'desc'
      this.totalSortDirection = this.totalSortDirection === 'asc' ? 'desc' : 'asc';

      let sortKey = 'total_issues';
      if (this.switchData === 'estimated') {
        sortKey = 'estimated';
      } else if (this.switchData === 'quantity') {
        sortKey = 'quantity';
      }

      // 1. Aggregate
      const accountTotals = {};
      this.ProductionData.forEach(item => {
        const accId = item.account_id;
        const accName = item.account_name;

        if (!accountTotals[accId]) {
          accountTotals[accId] = {
            id: accId,
            name: accName,
            total_issues: 0,
            estimated: 0,
            quantity: 0,
          };
        }

        accountTotals[accId].total_issues += item.total_issues || 0;
        accountTotals[accId].estimated += item.estimated || 0;
        accountTotals[accId].quantity += item.quantity || 0;
      });

      // 2. Sort
      let accountDataSorted = Object.values(accountTotals);
      accountDataSorted = lodash.orderBy(accountDataSorted, [sortKey, 'name'], [this.totalSortDirection, 'asc']);

      // 3. Add missing
      const existingIds = new Set(accountDataSorted.map(a => a.id));
      for (const item of this.backupAccountData) {
        if (!existingIds.has(item.id)) {
          accountDataSorted.push(item);
        }
      }

      // 4. Assign to final output
      this.accounData = accountDataSorted;
    },
    getProjectData(name) {
      if (name && name.length > 15) {
        let sliced = name.slice(0, 15);
        sliced = `${sliced}...`
        return sliced
      } else {
        return name
      }
    },
    getAccountTotal(aId) {
      let total = 0;
      let data = this.ProductionData.filter(k => k.account_id == aId)
      console.log(data, 'account id !!!')
      if (!this.switchData || this.switchData == 'issues') {
        total = data.reduce((sum, project) => sum + (project.total_issues || 0), 0);
      } else if (this.switchData == 'estimate') {
        total = data.reduce((sum, project) => sum + (project.estimated || 0), 0);
      } else if (this.switchData == 'quantity') {
        total = data.reduce((sum, project) => sum + (project.quantity || 0), 0);
      }
      console.log(total, 'total issue!!!')
      return Math.floor(total);
    },

    getProjectTotal(wId) {
      let total = 0;
      let data = this.ProductionData.filter(k => k.project_id == wId)
      if (!this.switchData || this.switchData == 'issues') {
        total = data.reduce((sum, project) => sum + (project.total_issues || 0), 0);
      } else if (this.switchData === 'estimate') {
        total = data.reduce((sum, project) => sum + (project.estimated || 0), 0);
      } else if ((this.switchData == 'quantity')) {
        total = data.reduce((sum, project) => sum + (project.quantity || 0), 0);
      }
      return Math.floor(total);
    },

    issueData(pId, aId) {
      // if (pId && aId) {
      // Emitting the event with Workspace ID and Account ID
      this.$emit("workspace-clicked", {
        projectId: pId,
        accountId: aId,
      });
      // }
    },

    getTotal() {
      let total = 0;
      if (this.ProductionData) {
        this.ProductionData.forEach((item) => {
          total += item && item.total_issues ? item.total_issues : 0;
        });
      }
      return total;
    },
  },
};
</script>

<style scoped>
/* Add a class to the "Total" column to keep it fixed */
.overflow {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 200px;
}

table {
  border-collapse: collapse;
  white-space: nowrap;
  width: fit-content;
}


.total-column {
  position: sticky;
  left: 0;
  background-color: #eef6fb;
  z-index: 3;
}

/* Set the header and "Total" column to be fixed */
thead {
  position: sticky;
  top: 0;
  background: #fff;
  z-index: 2;
}

/* Add padding and adjust white-space for the account name */
td.account-name {
  padding: 8px;
  /* Adjust the padding as needed */
  white-space: nowrap;
  position: relative;
  z-index: 4;
  /* Set a higher z-index to bring it to the front */
}

.scrollable-body {
  overflow-x: auto;
  max-height: 300px;
  /* Set the desired max height for the scrollable area */
}

.table-container {
  overflow-x: auto;
  max-height: 80vh;
  width: 100%;
  height: 100vh;
  overflow: auto;
}

/* Add a class to the "Total" column to keep it fixed */
td.total-column {
  position: sticky;
  left: 0;
  background-color: #eef6fb;
  z-index: 3;
}

/* Set the header and "Total" column to be fixed */
thead {
  position: sticky;
  top: 0;
  background: #fff;
}

/* Add padding and adjust white-space for the account name */
td.account-name {
  padding: 8px;
  /* Adjust the padding as needed */
  white-space: nowrap;
}

.scrollable-body {
  overflow: auto;
  max-height: 300px;
  /* Set the desired max height for the scrollable area */
  z-index: -1;
  /* Set the desired max height for the scrollable area */
}

.headerElem {
  white-space: nowrap;
  height: 11em;
}

.headerText {
  /* transform: rotate(-90deg); */
  position: relative;
  word-break: break-all;
  font-size: 16px;
  font-weight: 500;
}

td {
  padding: 6px;
  height: 42px;
  /* width: 50px; */
  text-align: center;
  font-size: 14px;
  font-weight: 400;
}

th:nth-child(1) {
  width: 150px !important;
  position: sticky;
  left: 0;
  background: #eef6fb;
  z-index: 3;
}

td:nth-child(1) {
  width: 150px !important;
  position: sticky;
  left: 0;
  text-align: left !important;
  font-size: 14px;
  font-weight: 700;
  background-color: #eef6fb;
}

th:last-child {
  /* width: 150px !important; */
  position: sticky;
  right: 0;
  z-index: 3;
}

td:last-child {
  /* width: 150px !important; */
  position: sticky;
  right: 0;
  font-size: 14px;
  font-weight: 700;
}

th:nth-child(odd) {
  /* width: 50px; */
}

td:nth-child(odd) {
  /* width: 50px; */
}

td:nth-child(even) {
  background: #e1eaef;
}

.rotate-90 {
  transform: rotate(90deg);
  margin: 50%;
}

/* Add these styles to your existing styles */

/* Set the first and last columns to stay fixed */
td.account-name,
td.total-column,
th.headerElem:nth-child(1),
th.headerElem.total-column {
  position: sticky;
  left: 0;
  background-color: #eef6fb;
  z-index: 3;
}

/* Set the first header cell to stay fixed */
th.headerElem:nth-child(1) {
  left: 0;
}

.total-header-cell {
  background-color: #eef6fb;
  /* Set the background color for the "Total" header cell */
}

/* Add a class for the "Total" value cells */
.total-column-cell {
  background-color: #eef6fb;
}

th.headerElem.total-column {
  position: sticky;
  left: 0;
  background-color: #eef6fb;
  z-index: 3;
  width: 20px !important;
}

/* Set the styles for the "Total" column header text */
.headerText.total-header {
  /* transform: rotate(-90deg); */
  position: relative;
  word-break: break-all;
  font-size: 16px;
  font-weight: 500;
}

/* Set the last header cell to stay fixed */
th.headerElem.total-column {
  position: sticky;
  left: auto;
  background-color: #eef6fb;
  z-index: 3;
  width: 20px !important;
}

/* Set the styles for the text within the header cells */
.headerText {
  transform: rotate(-90deg);
  position: relative;
  word-break: break-all;
  font-size: 16px;
  font-weight: 500;
  width: 50px;
  overflow: visible;
  position: relative;
  top: 40px;
}

/* Set the styles for the first column */
td.account-name {
  padding: 8px;
  /* Adjust the padding as needed */
  white-space: nowrap;
  position: relative;
  z-index: 4;
  /* Set a higher z-index to bring it to the front */
}

/* Adjust other styles as needed */

.total-row {
  position: sticky;
  bottom: 0;
  background-color: #eef6fb;
  z-index: 3;
}

.total-row td {
  font-weight: bold;
}

.headerElem:nth-child(even) {
  background: #e1eaef;
  width: 20px !important;
}


.first-column {
  width: auto;
  /* Let the width be determined by content */
}

.sort {
  position: absolute;
  top: -6px;
  right: -80px;
}

.sort1 {
  position: absolute;
  top: 13px;
  right: 14px;
}

/* Add a general style for other columns */
.table-container th:not(.first-column),
.table-container td:not(.first-column) {
  width: 30px !important;
  overflow: hidden;
  /* You can customize other styles here */
}
</style>
